const edulist=[
    {
        nameofcourse: "12th (CBSE)",
        nameofinstitute: "KV AMC",
        fromto: '2021'
    },

    {
        nameofcourse: "Bacheoler of Engineering (IT)",
        nameofinstitute: "AIT Pune",
        fromto: '2022-2026'
    },
    
]

export default edulist;